import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomNavbar from "../../../components/CustomNavbar";
import SidebarConfig from "../../../components/Clima/SidebarClimate";

const SettingsClimate = () => {
  const userRoles = useSelector((store) => store.auth.userRoles);

  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);
  return (
    <>
      <CustomNavbar onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container-fluid">
          <div className="jumbotron">
            <h1 className="font-weight-bold">Configuración de Clima Laboral</h1>
            <hr className="my-4" />
            <p className="mb-4">
              Desde aquí podrás administrar todas las configuraciones que
              corresponden a clima laboral, a continuación te mostramos algunos
              accesos rápidos para que puedas comenzar
            </p>
            <Row>
              <Col>
                <h4 className="mb-3">Crear cuestionarios</h4>
                <Link
                  className="btn btn-primary btn-lg"
                  to="/cuestionarios"
                  role="button"
                >
                  Cuestionarios
                </Link>
              </Col>
              <Col>
                <h4>Mantenimientos clima laboral</h4>
                <ul className="ml-3 p-0">
                  {userRoles.length > 0 &&
                  userRoles.includes("administrador") ? (
                    <li>
                      <Link to="/categorias">Mantenimiento de Categorias</Link>
                    </li>
                  ) : null}
                  {userRoles.length > 0 &&
                  userRoles.includes("administrador") ? (
                    <li>
                      <Link to="/mediciones">Mantenimiento de Mediciones</Link>
                    </li>
                  ) : null}
                  {userRoles.length > 0 &&
                  userRoles.includes("administrador") ? (
                    <li>
                      <Link to="/segmentación">Mantenimiento de segmento </Link>
                    </li>
                  ) : null}
                  {userRoles.length > 0 &&
                  userRoles.includes("responsable") &&
                  !userRoles.includes("administrador") ? (
                    <li>
                      <Link to="/segmentación">Mantenimiento de segmento </Link>
                    </li>
                  ) : null}
                  {userRoles.length > 0 &&
                  userRoles.includes("administrador") ? (
                    <li>
                      <Link to="/herramienta">
                        Mantenimiento de Tipo de Herramienta
                      </Link>
                    </li>
                  ) : null}
                  {userRoles.length > 0 &&
                  (userRoles.includes("administrador") ||
                    userRoles.includes("responsable")) ? (
                    <li>
                      <Link to="/campaña">Mantenimiento de Campaña </Link>
                    </li>
                  ) : null}
                  {userRoles.length > 0 &&
                  (userRoles.includes("responsable") ||
                    userRoles.includes("administrador")) ? (
                    <li>
                      <Link to="/clima-laboral/log">Registro actividades </Link>
                    </li>
                  ) : null}
                </ul>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
};

export default SettingsClimate;
